import React from 'react';
import {FaThermometerHalf} from 'react-icons/fa';

export function HVAC({...rest}) {
  return <FaThermometerHalf size={35} {...rest} />;
}
